import { lazy, Suspense } from 'react';
import Sidebar from '../components/layout/Sidebar';
import { Outlet, useLocation } from 'react-router-dom';
import { HideFromSuperAdmin } from '../components/common/RoleBasedAccess';
import { useFloatingChatStore } from '../store/FloatingChatStore';
import { FeaturesProvider } from '../contexts/FeaturesContext';
import PageLoadingFallback from '../components/common/PageLoadingFallback';
import { shouldHideFloatingChat } from './floatingChatVisibility';

const FloatingDocumentChat = lazy(
  () => import('../components/dashboard/FloatingDocumentChat'),
);

const MainLayout = () => {
  const { isOpen, query, scope, closeChatWithQuery } = useFloatingChatStore();
  const location = useLocation();
  const hideFloatingChat = shouldHideFloatingChat(location.pathname);

  return (
    <FeaturesProvider>
      <div className="flex h-screen bg-gradient-to-br from-indigo-100 via-indigo-50 to-indigo-100">
        <Sidebar />
        <div className="flex-1 flex justify-center overflow-auto h-[calc(100vh)] rounded-xl">
          <Suspense fallback={<PageLoadingFallback />}>
            <Outlet />
          </Suspense>
        </div>
        <Suspense fallback={null}>
          {!hideFloatingChat && (
            <HideFromSuperAdmin fallback={null}>
              <FloatingDocumentChat
                initialQuery={query}
                initialScope={scope}
                forceOpen={isOpen}
                onCloseCallback={closeChatWithQuery}
              />
            </HideFromSuperAdmin>
          )}
        </Suspense>
      </div>
    </FeaturesProvider>
  );
};

export default MainLayout;
